import { TableV2 as Table } from "@asayinc/component-library";
import { useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { ROW_OPTIONS } from "src/constants/options/rowOptions";
import { useTablePagination } from "src/hooks/useTablePagination";
import { useClassActionEventsQuery } from "src/store/classActionEvent";
import { getColumnData, getColumns, getRowData } from "./utils";
import { IClassActionEvent } from "src/store/classActionEvent/types";
import { ScrollContainer } from "src/components/containers/ScrollContainer";

export function IssuerClassActionEvents() {
  const { id: issuerId } = useParams() as { id: string };
  const navigate = useNavigate();

  const {
    getSort,
    offset,
    limit,
    ordering,
    onChangePage,
    onChangeRows,
    onOrderingChange,
  } = useTablePagination();

  const { data, isFetching, isLoading } = useClassActionEventsQuery({
    offset,
    limit,
    ordering,
    issuerId,
  });

  const paginateProps = {
    onChangePage,
    onChangeRows,
    rowOptions: ROW_OPTIONS,
    count: data?.count || 0,
    page: Math.floor(offset / limit) + 1,
    rowsPerPage: limit,
  };

  const handleRowClick = (event: IClassActionEvent) => {
    const { id } = event;
    navigate(`/class-action-events/${id}/details`);
  };

  const columns = useMemo(() => getColumns(), []);
  const columnData = useMemo(() => {
    return getColumnData({
      getSort,
      onOrderingChange,
    });
  }, [getSort, onOrderingChange]);
  const rowData = getRowData(data?.results || [], handleRowClick);

  return (
    <ScrollContainer sx={{ pt: 8, pb: 10, pl: 10, pr: 6.25 }}>
      <Table
        count={data?.count || 0}
        columnData={columnData}
        columns={columns}
        isFetching={isFetching}
        isLoading={isLoading}
        noResultsData={{
          title: "No Class Action Events found for this issuer",
          subtitle: "Sorry, there are no Class Action Events for this issuer.",
        }}
        paginateProps={paginateProps}
        rows={rowData}
        tableMinWidth={900}
        title="Class Action Events"
        titleVariant="subtitle2"
        toolbarInside
      />
    </ScrollContainer>
  );
}
